import { useState } from 'react';
import { faqItems } from '@/mocks/cinema';

export default function SectionFAQ() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section id="faq" className="py-16 md:py-20 bg-background-50">
      <div className="section-container px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-100 mb-3">
            常见问题
          </h2>
          <p className="text-foreground-500 text-sm max-w-lg mx-auto">
            关于夜猫电影院的常见疑问，这里都有答案
          </p>
        </div>
        <div className="max-w-3xl mx-auto flex flex-col gap-3">
          {faqItems.map((item, i) => (
            <div
              key={i}
              className="rounded-xl bg-background-100 border border-background-200/30 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
                onClick={() => setOpenIndex(openIndex === i ? -1 : i)}
              >
                <h3 className="text-sm md:text-base font-medium text-foreground-200 pr-4">
                  {item.q}
                </h3>
                <i
                  className={`ri-arrow-down-s-line text-foreground-500 transition-transform duration-200 flex-shrink-0 ${
                    openIndex === i ? 'rotate-180' : ''
                  }`}
                />
              </button>
              {openIndex === i && (
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-500 leading-relaxed">{item.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}